import React from 'react';
import { HStack, Button, Text, VStack } from '@chakra-ui/react';
import { useOrg } from '../../context/OrgContext';

/**
 * Segmented control to preview the app as each org role. Placed on the Overview
 * and Settings pages per the design language - it changes what you can manage,
 * not what you can see.
 */
export default function PermissionPreview({ align = 'flex-end' }) {
  const { role, setRole, roles } = useOrg();
  return (
    <VStack align={align} spacing={1.5}>
      <Text fontSize="11px" fontWeight="600" textTransform="uppercase" letterSpacing="0.06em" color="gray.400">
        Preview permissions
      </Text>
      <HStack spacing={0} bg="gray.100" border="1px solid" borderColor="gray.200" borderRadius="full" p="3px">
        {roles.map((r) => {
          const active = r === role;
          return (
            <Button
              key={r}
              onClick={() => setRole(r)}
              variant="unstyled"
              h="26px"
              px={4}
              borderRadius="full"
              fontSize="12px"
              fontWeight={active ? '700' : '600'}
              textTransform="capitalize"
              color={active ? 'brand.600' : 'gray.500'}
              bg={active ? 'white' : 'transparent'}
              boxShadow={active ? '0 1px 2px rgba(0,0,0,0.08)' : 'none'}
              display="flex"
              alignItems="center"
            >
              {r}
            </Button>
          );
        })}
      </HStack>
    </VStack>
  );
}
